import { render, staticRenderFns } from "./PuntosGestionExport.vue?vue&type=template&id=1f44ee88"
import script from "./PuntosGestionExport.vue?vue&type=script&lang=js"
export * from "./PuntosGestionExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports